import React from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";

export const ComboBoxComponent = ({
  label,
  style,
  data,
  textField,
  filterable,
  onFilterChange,
  value,
  onChange,
  placeholder,
  className,
  disabled,
}) => (
  <div className="d-flex flex-column ">
    <Label className="label mb-1">{label}</Label>
    <ComboBox
      style={style}
      data={data}
      iconClassName="wa"
      textField={textField}
      filterable={filterable}
      onFilterChange={onFilterChange}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
    />
  </div>
);

